// extracted by mini-css-extract-plugin
export default {"h_bg":"Hiv_h_bg__oS5z2","h_nav":"Hiv_h_nav__Wzj-C","h_header":"Hiv_h_header__HaFEL"};